<template>
  <div>
    <PageTitle title="KOT Setting" />
    <v-container fluid class="lighten-12 ">
      <!-- <v-tabs v-model="tab" background-color="primary" dark>
          <v-tab class="card-tabs" v-for="item in items" :key="item.tab">{{
            item.tab
          }}</v-tab>
        </v-tabs> -->

      <!-- <pre>  {{ possetting }}</pre> -->

      <!-- {{possetting}} -->
      <!-- <v-tabs-items v-model="tab"> -->
      <!-- <v-tab-item> -->
      <!-- <v-container class="light gray lighten-12 c"> -->
      <!-- <v-card class="lighten-12 card-content"> -->

      <v-row>
        <v-col cols="9">
          <v-card class="lighten-12 card-content">
               <v-card-title>General</v-card-title>
            <v-container fluid >
           
              <v-row>
                <v-col cols="8">
                  <v-text-field
                    :error-messages="errors"
                    outlined
                    required
                    dense
                    v-model="kotsetting.kot_url"
                    hide-details="auto"
                    label="Kot url"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                    v-model="kotsetting.guest_id"
                    :items="guestTypeList"
                    item-text="name"
                    item-value="id"
                    :error-messages="errors"
                    outlined
                    required
                    dense
                    :search-input.sync="searchGuest"
                    hide-details="auto"
                    label="Guest"
                  ></v-autocomplete>
                </v-col>

                 <v-col cols="6">
                  <v-autocomplete
                    v-model="kotsetting.kitchen_id"
                    :items="KitchenList"
                    item-text="name"
                    item-value="id"
                    :error-messages="errors"
                    outlined
                    required
                    dense
                    hide-details="auto"
                    label="Kitchen"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    v-model="kotsetting.waiter_id"
                    :items="WaiterList"
                    item-text="name"
                    item-value="id"
                    :error-messages="errors"
                    outlined
                    required
                    dense
                    hide-details="auto"
                    label="Waiter"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                    v-model="kotsetting.place_id"
                    :items="PlaceList"
                    item-text="name"
                    item-value="id"
                    :error-messages="errors"
                    outlined
                    required
                    dense
                    hide-details="auto"
                    label="Place"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="6">
                  <v-select
                    dense
                    outlined
                    :items="option"
                    item-text="text"
                    item-value="value"
                    hide-details="auto"
                    label="Display Time"
                    v-model="kotsetting.display_time"
                  ></v-select>
                </v-col>

                <v-col cols="6">
                  <v-select
                    dense
                    outlined
                    :items="option"
                    item-text="text"
                    item-value="value"
                    hide-details="auto"
                    label="On Screen Keyboard"
                    v-model="kotsetting.on_screen_keyboard"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    dense
                    :items="option"
                    item-text="text"
                    item-value="value"
                    outlined
                    hide-details="auto"
                    label="Display Customer Details on Receipt"
                    v-model="kotsetting.display_customer_details_on_receipt"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    :error-messages="errors"
                    outlined
                    required
                    dense
                    v-model="kotsetting.service_charge"
                    hide-details="auto"
                    label="Service Charge"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-select
                    dense
                    outlined
                    :items="option"
                    item-text="text"
                    item-value="value"
                    hide-details="auto"
                    label="Progressive Web App (PWA)"
                    v-model="kotsetting.pwa_enabled"
                  ></v-select>
                  <div class="caption grey--text mt-1">
                    Enable so staff can install KOT on a POS computer (desktop app), a waiter phone, or a waiter tablet. Turn this off any time. Open KOT screens pick up the change within a minute and clear the installed app cache. Installation needs HTTPS, or localhost.
                  </div>
                </v-col>
              </v-row>
              <v-row align="end">
                <v-col cols="12">
                  <v-card-title class="px-0 pt-4 pb-2">KOT appearance &amp; calendar</v-card-title>
                </v-col>
                <v-col cols="6">
                  <ColorPicker
                    v-model="kotsetting.theme_primary_color"
                    outlined
                    dense
                    label="KOT theme color"
                  />
                  <div class="caption grey--text mt-1">
                    Primary buttons, header accents, and calendar highlights on KOT
                  </div>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    dense
                    outlined
                    type="number"
                    min="32"
                    max="120"
                    hide-details="auto"
                    clearable
                    label="Calendar day column width (px)"
                    v-model.number="kotsetting.calendar_day_col_px"
                    hint="Leave empty for default calendar column width"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    dense
                    outlined
                    type="number"
                    min="16"
                    max="64"
                    hide-details="auto"
                    clearable
                    label="Calendar booking row height (px)"
                    v-model.number="kotsetting.calendar_row_height_px"
                    hint="Height of each reservation bar in a room row"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    dense
                    outlined
                    type="number"
                    min="28"
                    max="80"
                    hide-details="auto"
                    clearable
                    label="Calendar date header height (px)"
                    v-model.number="kotsetting.calendar_header_height_px"
                    hint="Height of day number cells in the calendar header"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-select
                    dense
                    outlined
                    :items="calendarTextAlignOptions"
                    item-text="label"
                    item-value="value"
                    hide-details="auto"
                    label="Calendar text alignment"
                    v-model="kotsetting.calendar_text_align"
                  ></v-select>
                  <div class="caption grey--text mt-1">
                    Alignment of day headers and reservation bar labels on KOT calendar
                  </div>
                </v-col>
                <v-col cols="6">
                  <v-select
                    dense
                    outlined
                    :items="option"
                    item-text="text"
                    item-value="value"
                    hide-details="auto"
                    label="Show time on calendar grid"
                    v-model="kotsetting.calendar_show_time"
                  ></v-select>
                  <div class="caption grey--text mt-1">
                    Shows 12:00 check-in and check-out time on the KOT reservation calendar. Set this to no to hide it.
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
           <v-row>
        <v-col cols="9">
      <v-card-actions class="justify-content-end">
    
        <div>
          <btn-cancel></btn-cancel>
          <v-btn
            depressed
            small
            class="text-white btn_blue btn_medium w-100"
            @click="submit"
            >Update</v-btn
          >
        </div>
      </v-card-actions>
        </v-col></v-row>
    </v-container>
  </div>
</template>

<script>

import axios from "@/plugins/axios";
import ColorPicker from "@/components/base/ColorPicker.vue";
import { buildKotConfigurationPatchBody } from "@/utils/kotConfigurationPayload";

export default {
  data() {
    return {
      isLoading: false,
      tab: null,
      shops: [],
      items: [{ tab: "POS Configuration" }],
      kotsetting: {},
      option: [
        { text: "yes", value: true },
        { text: "no", value: false },
      ],
      calendarTextAlignOptions: [
        { value: "left", label: "Left" },
        { value: "center", label: "Center" },
        { value: "right", label: "Right" },
      ],
      categories: [],
      guestTypeList: [],
      KitchenList:[],
      WaiterList:[],
      PlaceList:[],
      temp: "",
      searchGuest: null,
      errors: [],
      messages: "",
    };
  },
  components: {
    ColorPicker,
  },
  watch: {
    searchGuest(val) {
      this.GetGuestType(val);
    },
  },
  methods: {
    apiErrorMessage(err) {
      if (!err) return "Request failed";
      const data = err.data || (err.response && err.response.data);
      const fieldErrors = (data && data.error) || (data && data.errors);
      if (fieldErrors && typeof fieldErrors === "object") {
        const parts = Object.values(fieldErrors).filter(Boolean);
        if (parts.length) return parts.join(". ");
      }
      return (data && (data.title || data.message)) || err.message || "Request failed";
    },
    async submit() {
      this.UpdateSetting();
    },
    GetGuestType(query = "") {
      this.isLoading = true;
       axios
        .get(`hms/guests`, {
          params: {
            query: query,
            size: 20,
          }
        })
        .then((res) => {
          
          this.guestTypeList = res.data.data;
          this.isLoading = false;
        })
        .catch((err) => {
          this.messages = this.apiErrorMessage(err);
          this.isLoading = false;
        });
    },
     GetKitchenType() {
      this.isLoading = true;
       axios
        .get(`hms/kitchens`)
        .then((res) => {
          
          this.KitchenList = res.data.data;
          this.isLoading = false;
        })
        .catch((err) => {
          this.messages = this.apiErrorMessage(err);
          this.isLoading = false;
        });
    },

    GetWaiter() {
      this.isLoading = true;
       axios
        .get(`hms/waiters`)
        .then((res) => {
          
          this.WaiterList = res.data.data;
          this.isLoading = false;
        })
        .catch((err) => {
          this.messages = this.apiErrorMessage(err);
          this.isLoading = false;
        });
    },

    GetPlace() {
      this.isLoading = true;
       axios
        .get(`hms/places`)
        .then((res) => {
          
          this.PlaceList = res.data.data;
          this.isLoading = false;
        })
        .catch((err) => {
          this.messages = this.apiErrorMessage(err);
          this.isLoading = false;
        });
    },


    applySettingFromApi(data) {
      const row = data || {};
      this.kotsetting = {
        ...row,
        guest_id: row.guest_id != null ? row.guest_id : row.guest && row.guest.id,
        kitchen_id:
          row.kitchen_id != null ? row.kitchen_id : row.kitchen && row.kitchen.id,
        waiter_id:
          row.waiter_id != null ? row.waiter_id : row.waiter && row.waiter.id,
        place_id: row.place_id != null ? row.place_id : row.place && row.place.id,
        theme_primary_color: row.theme_primary_color || "#512d82",
        calendar_text_align: row.calendar_text_align || "left",
        calendar_show_time: !(
          row.calendar_show_time === false ||
          row.calendar_show_time === 0 ||
          row.calendar_show_time === "0" ||
          row.calendar_show_time === "false"
        ),
        pwa_enabled:
          row.pwa_enabled === true ||
          row.pwa_enabled === 1 ||
          row.pwa_enabled === "1",
      };
    },
    UpdateSetting() {
      this.isLoading = true;
      const kot = buildKotConfigurationPatchBody(this.kotsetting);
      if (
        kot.kitchen_id == null ||
        kot.waiter_id == null ||
        kot.place_id == null
      ) {
        this.$toast.error("Please select Kitchen, Waiter, and Place");
        this.isLoading = false;
        return;
      }
      if (!kot.kot_url) {
        this.$toast.error("KOT URL is required");
        this.isLoading = false;
        return;
      }
      this.$store
        .dispatch("UpdateKotSetting", kot)
        .then((res) => {
          this.succeeed = true;

          this.$toast.success("KOT setting updated  successfully");
          // this.$router.push({ path: "/" });
          this.isLoading = false;
        })
        .catch((err) => {
          const msg = this.apiErrorMessage(err);
          this.$toast.error(msg || "KOT setting update failed");
          this.messages = msg;
          this.isLoading = false;
        });
    },
    GetSetting() {
       this.$store
        .dispatch("GetKOTSettings")
        .then((res) => {
          this.applySettingFromApi(res.data);
        })
        .catch((err) => {
          this.messages = this.apiErrorMessage(err);
          this.isLoading = false;
        });
    },
  },
  created() {
    this.GetSetting();
    this.GetGuestType();
    this.GetKitchenType();
    this.GetWaiter();
    this.GetPlace();
  },
};
</script>
